module.exports = "/assets/646ad64478cc12907c8a7f98cf64d461.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FS.png
// module id = 1380
// module chunks = 0